/**
 * Room themes. Host can switch between these via the ⚙️ Settings panel.
 * Each theme defines the background + the buzzer color + the accent color.
 * Players see the theme the host picked.
 */
export const THEMES = {
  default: {
    id: "default",
    label: "Neon Default",
    emoji: "💜",
    bgImage:
      "https://static.prod-images.emergentagent.com/jobs/ba4edadb-020c-47f9-a06b-b370a6073d94/images/69a7b3ac756fc18520700770faf413c3b08bf8d01c6df5f955c40d438380cfa1.png",
    bgGradient: null,
    buzzerColor: "#FF0055",
    buzzerGlow: "rgba(255,0,85,0.6)",
    accentColor: "#00F0FF",
    titleColor: "#FFEA00",
  },
  gameshow: {
    id: "gameshow",
    label: "Game Show",
    emoji: "🎰",
    bgImage: null,
    bgGradient:
      "radial-gradient(ellipse at top, #831843 0%, #4C1D95 50%, #18181B 100%)",
    buzzerColor: "#FFD700",
    buzzerGlow: "rgba(255,215,0,0.7)",
    accentColor: "#FFEA00",
    titleColor: "#FFD700",
  },
  classroom: {
    id: "classroom",
    label: "Classroom",
    emoji: "📚",
    bgImage: null,
    bgGradient: "linear-gradient(135deg, #0F172A 0%, #1E40AF 60%, #0E7490 100%)",
    buzzerColor: "#3B82F6",
    buzzerGlow: "rgba(59,130,246,0.6)",
    accentColor: "#10B981",
    titleColor: "#FBBF24",
  },
  sports: {
    id: "sports",
    label: "Sports Arena",
    emoji: "🏟️",
    bgImage: null,
    bgGradient:
      "radial-gradient(circle at 30% 50%, #7F1D1D 0%, #18181B 70%, #000000 100%)",
    buzzerColor: "#DC2626",
    buzzerGlow: "rgba(220,38,38,0.7)",
    accentColor: "#FBBF24",
    titleColor: "#FBBF24",
  },
  retro: {
    id: "retro",
    label: "Retro Arcade",
    emoji: "🕹️",
    bgImage: null,
    bgGradient:
      "linear-gradient(135deg, #581C87 0%, #BE185D 50%, #F59E0B 100%)",
    buzzerColor: "#F97316",
    buzzerGlow: "rgba(249,115,22,0.7)",
    accentColor: "#FACC15",
    titleColor: "#FACC15",
  },
  ocean: {
    id: "ocean",
    label: "Ocean",
    emoji: "🌊",
    bgImage: null,
    bgGradient: "linear-gradient(135deg, #0C4A6E 0%, #134E4A 50%, #064E3B 100%)",
    buzzerColor: "#06B6D4",
    buzzerGlow: "rgba(6,182,212,0.6)",
    accentColor: "#34D399",
    titleColor: "#A7F3D0",
  },
};

export const getTheme = (id) => THEMES[id] || THEMES.default;
